<template>
    <div class="conter_share" v-if="bShowNrom">
        <div class="back_Groud" @click="getShowNrom"></div>
        <div class="bottom_share" :class="{ show: bShowNrom }">
            <div class="top">
                <div>分享方式</div>
                <div @click="getShowNrom">
                    <img
                        src="~@/assets/images/ant/details/cha_icon.png"
                        alt=""
                    />
                </div>
            </div>
            <div class="wxHh item">
                <div class="left">
                    <img
                        class="hh_icon"
                        src="~@/assets/images/ant/details/hh_icon.png"
                        alt=""
                    />
                    <div>
                        <div>工具栏会话</div>
                        <div>发送内容到会话</div>
                    </div>
                </div>
                <div class="right" @click="getQyhh">发送到会话</div>
            </div>
            <div class="wxchat item">
                <div class="left">
                    <img
                        class="link_icon"
                        src="~@/assets/images/ant/details/link_icon.png"
                        alt=""
                    />
                    <div>
                        <div>朋友圈链接</div>
                        <div>复制链接后去朋友圈发布</div>
                    </div>
                </div>
                <div
                    class="right"
                    @click="getQywx"
                    :data-clipboard-text="confit.share_link"
                    id="express_info_right"
                >
                    点击复制
                </div>
            </div>
        </div>
        <div class="shareTips" v-if="bShareTips">请点击右上角···转发哦~</div>
    </div>
</template>
<script>
import { Toast } from "mint-ui";
export default {
    props: {
        bShowNrom: {
            type: Boolean,
            defatule: false,
        },
        confit: {
            type: Object,
            defatule: false,
        },
    },
    data() {
        return {
            bShareTips: false,
        };
    },
    mounted() {},
    methods: {
        getShowNrom() {
            this.$emit("update:bShowNrom", false);
        },
        getQyhh() {
            let that = this;
            let wechat = this.$storage.getStorage("is_wechat");
            if (wechat == 1) {
                this.bShareTips = true;
                setTimeout(() => {
                    this.bShareTips = false;
                }, 1500);
            } else if ((wechat = 6)) {
                let confit = this.confit;
                //分享到会话
                wx.invoke("getContext", {}, function (res) {
                    //  console.log("分享到会话", res);
                    if (res.err_msg == "getContext:ok") {
                        let entry = res.entry; //返回进入H5页面的入口类型，目前有normal、contact_profile、single_chat_tools、group_chat_tools
                        if (entry == "normal") {
                            wx.invoke(
                                "shareAppMessage",
                                {
                                    title: confit.share_friend_title, // 分享标题
                                    desc: confit.share_friend_desc, // 分享描述
                                    imgUrl: confit.share_img_url, // 分享封面
                                    link: confit.share_link, // 分享链接
                                },
                                function (res) {
                                    //  console.log("企业微信会话", res);
                                    if (res.err_msg == "shareAppMessage:ok") {
                                        that.$emit("update:bShowNrom", false);
                                    } else if (
                                        res.err_msg == "shareAppMessage:cancel"
                                    ) {
                                        that.$emit("update:bShowNrom", false);
                                    }
                                }
                            );
                        } else if (
                            entry == "single_chat_tools" ||
                            entry == "group_chat_tools"
                        ) {
                            wx.invoke(
                                "sendChatMessage",
                                {
                                    msgtype: "news", //消息类型，必填
                                    news: {
                                        link: confit.share_link, //H5消息页面url 必填
                                        title: confit.share_friend_title, //H5消息标题
                                        desc: confit.share_friend_desc, //H5消息摘要
                                        imgUrl: confit.share_img_url, //H5消息封面图片URL
                                    },
                                },
                                function (res) {
                                    //  console.log("服务指引返回结果", res);
                                    if (res.err_msg == "sendChatMessage:ok") {
                                        that.$emit("update:bShowNrom", false);
                                        //发送成功
                                    } else if (
                                        res.err_msg == "shareAppMessage:cancel"
                                    ) {
                                        that.$emit("update:bShowNrom", false);
                                    }
                                }
                            );
                        }
                    } else {
                        //  console.log("错误处理");
                        //错误处理
                    }
                });
            }
        },
        getQywx() {
            let that = this;
            let clipboard = new this.$clipboard("#express_info_right");
            clipboard.on("success", function () {
                Toast({
                    message: "复制成功",
                    duration: 1200,
                });
                clipboard.destroy();
            });
            clipboard.on("error", function () {
                Toast({
                    message: "复制失败",
                    duration: 1200,
                });
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.shareTips {
    height: 80px;
    width: 70%;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 999999;
    background: rgba(0, 0, 0, 0.788);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 28px;
    margin: auto;
    // pointer-events: none;
}
.conter_share {
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    .back_Groud {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.308);
    }
    .bottom_share {
        position: absolute;
        bottom: 0;
        z-index: 2;
        height: auto;
        width: 100%;
        padding: 30px 36px 150px;
        box-shadow: 0px 0px 30px 0px rgba(168, 183, 251, 0.4);
        border-top-left-radius: 30px;
        border-top-right-radius: 30px;
        background: #fff;
        &.show {
            animation: top 0.2s ease-in-out forwards;
        }
        .top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            div {
                font-size: 30px;
                img {
                    width: 20px;
                    height: 20px;
                }
            }
        }
        .item {
            width: 100%;
            height: 140px;
            padding: 0 30px;
            background-color: #f7f7fd;
            border-radius: 12px;
            margin-top: 30px;
            &:first-child {
                margin-top: 0;
            }
        }
        .wxHh,
        .wxchat {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .left {
                display: flex;
                align-items: center;
                .hh_icon {
                    width: 68px;
                    height: 56px;
                    margin-right: 43px;
                }
                .link_icon {
                    width: 52px;
                    height: 52px;
                    margin-right: 43px;
                }
            }
            .right {
                width: 170px;
                height: 58px;
                background-color: #023f88;
                border-radius: 29px;
                border: solid 0px #5c77f0;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #fff;
                font-size: 26px;
            }
        }
    }
}
@keyframes top {
    0% {
        transform: translateY(100%);
    }
    100% {
        transform: translateY(0);
    }
}
</style>
